import { formConstants } from '../constants';

export function contacts(state = {}, action) {
  switch (action.type) {
    case formConstants.CONTACTS_GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case formConstants.CONTACTS_GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case formConstants.CONTACTS_GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function GetContact(state = {}, action) {
  switch (action.type) {
    case formConstants.CONTACTS_GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case formConstants.CONTACTS_GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case formConstants.CONTACTS_GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function BranchRequests(state = {}, action) {
  switch (action.type) {
    case formConstants.BRANCH_REQUESTS_GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case formConstants.BRANCH_REQUESTS_GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case formConstants.BRANCH_REQUESTS_GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function GetBranchRequest(state = {}, action) {
  switch (action.type) {
    case formConstants.BRANCH_REQUESTS_GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case formConstants.BRANCH_REQUESTS_GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case formConstants.BRANCH_REQUESTS_GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function Jobs(state = {}, action) {
  switch (action.type) {
    case formConstants.JOBS_GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case formConstants.JOBS_GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case formConstants.JOBS_GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function GetJob(state = {}, action) {
  switch (action.type) {
    case formConstants.JOBS_GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case formConstants.JOBS_GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case formConstants.JOBS_GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}
